import { Alert } from "@mui/material";
import { FunctionComponent, useEffect } from "react";

interface Props {
  message: string;
  timer?: number;
  onTimerEnd?: () => void;
  onClose: () => void;
}

const TimesheetAlert: FunctionComponent<Props> = (
  props: Props
): JSX.Element => {
  const { message, timer, onTimerEnd, onClose } = props;

  useEffect(() => {
    if (timer && onTimerEnd) {
      setTimeout(() => {
        onTimerEnd();
      }, timer);
    }
  }, []);

  return (
    <Alert severity="success" onClose={onClose} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
};

export default TimesheetAlert;
